#!/usr/bin/env node

import { Command } from 'commander';
import chalk from 'chalk';
import { readFileSync } from 'fs';
import { fileURLToPath } from 'url';
import { dirname, join } from 'path';
import { registerCreateCommand } from './commands/create.js';
import { registerTemplateCommand } from './commands/template.js';

// 获取当前文件的目录
const __filename = fileURLToPath(import.meta.url);
const __dirname = dirname(__filename);

// 读取package.json
const packageJsonPath = join(__dirname, '../package.json');
const packageJson = JSON.parse(readFileSync(packageJsonPath, 'utf-8'));

// 创建CLI程序
const program = new Command();

program
  .name('zh')
  .description('一个通用的CLI脚手架工具，支持从Git仓库拉取模板')
  .version(packageJson.version, '-v, --version', '显示版本号')
  .helpOption('-h, --help', '显示帮助信息');

// 注册命令
registerCreateCommand(program);
registerTemplateCommand(program);

// 自定义帮助信息
program.on('--help', () => {
  console.log('');
  console.log(chalk.bold('示例:'));
  console.log('  $ zh template add vue3 github:vitejs/vite#templates/vue');
  console.log('  $ zh template list');
  console.log('  $ zh create my-project');
  console.log('  $ zh create my-project -t vue3');
  console.log('');
});

// 解析命令
program.parse(process.argv);

// 如果没有提供命令，显示帮助信息
if (!process.argv.slice(2).length) {
  program.outputHelp();
}
